export enum Role {
    User = 'User',
    Admin = 'Admin',
    AdminDashboard = 'adminE6kdonation',
    UserDashboard = 'adminOrganisation'
}